import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import { NavMarker } from 'react-rhumb';
import { STARTER, FREE } from 'self-service-api/constants/ProductLevels';
import getUsageTracker from 'pricing-pages-lib/utils/getUsageTracker';
import { SCREENS } from 'pricing-pages-ui/constants/tracking/Locations';
import Screens from '../../constants/routing/Screens';
import { CMS, MARKETING, OPERATIONS, SALES, SERVICE } from 'self-service-api/constants/ProductLines';
import { getHighlightsForProductLine, getProductLevelFromApiNameString } from 'ui-addon-upgrades/_core/features/FeaturesUtils';
import ProductInfoContainer from '../common/ProductInfoContainer';
import { SuiteTiles } from '../merch-card/SuiteTiles';
import { useFeatureStore } from '../../hooks/useFeatureStore';
import SuiteFeatureTable from '../feature-table/SuiteFeatureTable';
import Ebx633HeroBanner from './Ebx633HeroBanner';
import WhyGoHubSpotSection from '../free-tools-page/WhyGoHubSpotSection';
import { STARTER as StarterTab } from '../../constants/routing/Tabs';
import { useAnchorLinkScroll } from '../../hooks/htmlElementHooks';
import { useDocumentTitle } from '../../hooks/useDocumentTitle';
import { useTrackRetail } from '../../hooks/useTrackRetail';

const Ebx633LandingPage = () => {
  useAnchorLinkScroll();
  useTrackRetail();
  useDocumentTitle('starterCrmSuite');
  useEffect(() => {
    getUsageTracker().track('pageView', {
      screen: SCREENS.SUITE_STARTER
    });
  }, []);
  const productLevels = [FREE, STARTER];

  const buildFilteredHighlightedProducts = productLine => {
    const highlightedProducts = getHighlightsForProductLine(productLine);
    return highlightedProducts.filter(apiName => {
      const localProductLevel = getProductLevelFromApiNameString(apiName);
      return productLevels.includes(localProductLevel);
    });
  };

  useFeatureStore({
    highlightedProducts: buildFilteredHighlightedProducts(MARKETING),
    productLine: MARKETING
  });
  useFeatureStore({
    highlightedProducts: buildFilteredHighlightedProducts(SALES),
    productLine: SALES
  });
  useFeatureStore({
    highlightedProducts: buildFilteredHighlightedProducts(SERVICE),
    productLine: SERVICE
  });
  useFeatureStore({
    highlightedProducts: buildFilteredHighlightedProducts(OPERATIONS),
    productLine: OPERATIONS
  });
  useFeatureStore({
    highlightedProducts: buildFilteredHighlightedProducts(CMS),
    productLine: CMS
  });
  const productsByProductLine = {
    [MARKETING]: buildFilteredHighlightedProducts(MARKETING),
    [SALES]: buildFilteredHighlightedProducts(SALES),
    [SERVICE]: buildFilteredHighlightedProducts(SERVICE),
    [OPERATIONS]: buildFilteredHighlightedProducts(OPERATIONS),
    [CMS]: buildFilteredHighlightedProducts(CMS)
  };
  return /*#__PURE__*/_jsxs("div", {
    "data-selenium-id": "page-success",
    children: [/*#__PURE__*/_jsx(NavMarker, {
      name: "EBX633_LANDING_PAGE"
    }), /*#__PURE__*/_jsx(Ebx633HeroBanner, {}), /*#__PURE__*/_jsxs(ProductInfoContainer, {
      style: {
        margin: 'auto'
      },
      children: [/*#__PURE__*/_jsx(SuiteTiles, {
        selectedTab: StarterTab,
        isEbx633: true
      }), /*#__PURE__*/_jsx(SuiteFeatureTable, {
        productsByProductLine: productsByProductLine,
        screen: Screens.SUITE_STARTER,
        tab: StarterTab,
        isEbx633: true
      }), /*#__PURE__*/_jsx(WhyGoHubSpotSection, {
        selectedNavItem: "suite-starter",
        containerStyles: {
          width: '100vw',
          marginBottom: 0
        }
      })]
    })]
  });
};

export default Ebx633LandingPage;